import { render } from "./CustomerFeedBackSlider.vue?vue&type=template&id=1c5330ea&scoped=true&ts=true"
import script from "./CustomerFeedBackSlider.vue?vue&type=script&lang=ts"
export * from "./CustomerFeedBackSlider.vue?vue&type=script&lang=ts"

import "./CustomerFeedBackSlider.vue?vue&type=style&index=0&id=1c5330ea&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5330ea"]])

export default __exports__